import gql from "graphql-tag";

export const GET_TOURNAMENT = gql`
    query {
        tournaments(
            filters: {
                tour_status: {
                    ne: "cancelled"
                }
            },
            sort: ["createdAt:desc"]
        ) {
            id
            name
            tour_status
            is_feature
            date_start
            date_end
            reg_start_date
            reg_end_date
            contact_phone
            contact_address
            rule
            level
            type
            award_total
            num_player
            organizer
            categories {
                name
            }
            description
            photo {
                documentId
                url
            }
            sponsors {
                name
            }
            arenas {
                name
                address
            }
        }
    }
`;

export const GET_TOURNAMENT_BY_NAME = gql`
  query GetTournaments($name: String!) {
    tournaments(filters: { 
      name: { contains: $name }
    }) {
      data {
        id
        name
        documentId
        tour_status
        is_feature
        date_start
        date_end
        reg_start_date
        reg_end_date
        contact_phone
        contact_address
        rule
        level
        type
        award_total
        num_player
        organizer
        categories {
            documentId
            name
            type
        }
        description
        photo {
            documentId
            url
        }
        sponsors {
            name
        }
        arenas {
            name
            address
            courts {
                name
            }
        }
      }
    }
  }
`;

export const GET_TOURNAMENT_PAGINATE = gql`
  query GetTournament($page: Int!, $pageSize: Int!, $filters: TournamentFiltersInput) {
    tournaments_connection(
      pagination: { page: $page, pageSize: $pageSize }
      filters: $filters
      sort: ["createdAt:desc"]
    ) {
      nodes {
        documentId
      }
      pageInfo {
        page
        pageCount
        pageSize
        total
      }
    }
  }
`;

export const GET_TOURNAMENT_PLAYERS = gql`
    query GetTournamentPlayers(
        $page: Int
        $pageSize: Int
        $filters: TourPlayerFiltersInput
    ) {
        tourPlayers_connection(
            filters: $filters
            sort: ["createdAt:desc"]
            pagination: { page: $page, pageSize: $pageSize }
        ) {
            nodes {
                documentId
                player {
                    documentId
                    first_name
                    last_name
                    middle_name
                    display_name
                }
                categories {
                    documentId
                    name
                }
                tour_player_status
            }
            pageInfo {
                page
                pageCount
                pageSize
                total
            }
        }
    }
`;

export const GET_TOURNAMENT_BY_PLAYER = gql`
    query GetTournamentsByPlayer($documentId: ID!, $page: Int!, $pageSize: Int!, $keyword: String!) {
        tournaments_connection(
            filters: {
                or: [
                    {
                        teams: {
                            players: {
                                documentId: {
                                    eq: $documentId
                                }
                            }
                        }
                    },
                    {
                        tour_players: {
                            player: {
                                documentId: {
                                    eq: $documentId
                                }
                            }
                        }
                    }
                ],
                name: {
                    contains: $keyword
                }
            }
            pagination: { page: $page, pageSize: $pageSize }
            sort: ["createdAt:desc"]
        ) {
            nodes {
                name
                tour_status
                is_feature
                date_start
                date_end
                reg_start_date
                reg_end_date
                contact_phone
                contact_address
                rule
                level
                type
                award_total
                num_player
                organizer
                contain_categories
                categories {
                    name
                }
                description
                photo {
                    documentId
                    url
                }
                sponsors {
                    name
                }
                arenas {
                    name
                    address
                }
                tour_matches(pagination: { limit: 100 }) {
                    documentId
                    start_date
                    match_code
                    umpire {
                        documentId
                        name
                    }
                    tour_player_team_1 {
                        documentId
                        player_1 {
                            documentId
                            display_name
                            phone
                            address
                        }
                        player_2 {
                            documentId
                            display_name
                            phone
                            address
                        }
                    }
                    tour_player_team_2 {
                        documentId
                        player_1 {
                            documentId
                            display_name
                            phone
                            address
                        }
                        player_2 {
                            documentId
                            display_name
                            phone
                            address
                        }
                    }
                    tour_match_status
                    score
                    score_detail
                    court {
                        name
                        arena {
                            name
                            address
                        }
                    }
                    round {
                        name
                    }
                    winner {
                        documentId
                        player_1 {
                            documentId
                            display_name
                            phone
                            address
                        }
                        player_2 {
                            documentId
                            display_name
                            phone
                            address
                        }
                    }
                    category {
                        name
                    }
                    court {
                        name
                        arena {
                            name
                            contact_phone
                            address
                        }
                    }
                }
            }
            pageInfo {
                page
                pageCount
                pageSize
                total
            }
        }
    }
`;